import React, {Component} from 'react';
import Header from '../../Layout/Header'
import {Link} from 'react-router-dom'
import Sidebar from './Sidebar'

class GoogleAds extends Component {
    render() {
        return (
            <div>
                <Header
                    seoTitle="Google Ads"
                    title={"google ads"}
                    image={require('./image-8.jpg')}/>

                <div className="entry-content page-blog">

                    <div className="container-fluid">
                        <h2 className="outline text-center">
                            <div className="line"></div>
                            <div className="title">
                                <img
                                    src={require("./moshi-icon.png")}
                                    alt="Icon"
                                    width="48"
                                    style={{
                                    marginTop: -18,
                                    marginBottom: -12,
                                    marginRight: 12
                                }}/>
                                Google Ads
                            </div>
                        </h2>
                    </div>

                    <div className="container">
					
							<div className="row">
								<div className="col-lg-12">
									<p>Everyone has been on Google at some point and seen a Google Ad, whether they
										realise it or not. Our team are <b>Google Certified</b> (that means we pretty much
										ARE Google), and can run a wide range of ads across Google and their Partner
										sites for you.
									</p>
										
									<img
										src={require('./Moshi-ads.png')}
										width="350"
										alt="Moshi Marketing Ads"
									/>
									<p>Simply put, <b>Google Ads</b> (formerly AdWords) puts your ads above search results
										on Google. This means that if anyone is actively searching for products similar
										to yours, or with the same search terms as your ad content, your ads will
										appear. These ads (Google Search) are based on a bidding and quality score
										system (a rating of your landing page experience, content quality and ad
										quality).
									</p>
									<p>Our Google Ads technicians at Moshi Moshi are obsessed with data and giving
										you the best ROI on your ad spend, and have over 15 years experience in the
										Google Ads game. If Google Search is something you’d like to start, give us a
										call to set up a no obligation meeting with our data wizards.</p>
									<br></br>
									<hr></hr>
									<h4>Here at Moshi Moshi, we specialise in:
									</h4>

									<ul class="with-icons">
										<li>Google Search ads (text based)</li>
										<li>Google Display ads (image and text)</li>
										<li>Google Display Remarketing ads</li>
										<li>YouTube, TrueView and In-Stream Video ads</li>
									</ul>
									<br></br>
									<hr></hr>
									<img
										src={require('./Moshi-Display.png')}
										style={{
										padding: 30
									}}
										height="375"
										width="350"
										alt="Moshi Display Ads"
										className="align-right"
										align="right"/>
									<h1>Google Display</h1>
									<p>Google Display ads are static or animated banner images that you can see in
										the margins of Google partner sites. We use Google’s machine learning to create
										hundreds of different combinations of ads for you, and are able to see who
										clicked what ad, on what device, which operating system, at what time of day.
										With these analytics we can build the best campaigns for you that will give the
										highest ROI.
									</p>
									<h1>Google Display Remarketing
									</h1>
									<p>Google Display Remarketing ads are image ads shown to people who have been on
										your site before or taken an action on your site. The Moshi Moshi marketeers
										have been working on Google Display Remarketing ads for so long that our methods
										of targeting and content are like a results-generating, well oiled machine.
									</p>
									<br></br>
									<hr></hr>
									<img
										src={require('./youtube-ads.png')}
										style={{
										padding: 15
									}}
										height="375"
										width="350"
										alt="Youtube Marketing Ads"
										className="align-left"
										align="left"/>
									<h1>YouTube, TrueView and In-Stream Video
									</h1>
									<p>These are video ads that play either at the beginning of a Youtube clip, the
										middle of a clip, or that are placed throughout relevant articles, quizzes, news
										reports and similar web pages.
									</p>
									<p>These videos need to be straight to the point, have a clear call to action,
										and be captivating to your audience, as most people are inclined to skip after
										the first 3 seconds if they’re not intrigued. That’s why it’s best to get Moshi
										Moshi advice on the best placements, bids and audiences to target for the best
										ROAS you can get. We also offer <a href="https://www.moshi.com.au/whatwedo/video-production-and-advertising">videography services</a> if you need.</p>

									<br></br>
									<hr></hr>

									<h2>Related Services</h2>
									<a class="btn" href="https://www.moshi.com.au/whatwedo/website-development">Website Development</a>
									<a class="btn" href="https://www.moshi.com.au/whatwedo/social-media-marketing">Social Media Marketing</a>
									<a class="btn" href="https://www.moshi.com.au/whatwedo/public-relations">Public Relations</a>
									<a
										class="btn"
										href="https://www.moshi.com.au/whatwedo/photography-and-video-shoots">Photography and Video Shoots</a>
									<a
										class="btn"
										href="https://www.moshi.com.au/whatwedo/video-production-and-advertising">Video Production and Advertising</a>

									<a class="btn" href="https://www.moshi.com.au/whatwedo/social-media-management">Social Media Management</a>

								</div>
								{/* <div className="col-lg-4">
									<Sidebar />
								</div> */}
							</div>
							<hr></hr>
							<br></br>
							<h3>Google Advertising is something you really need an expert to run. For cost
								effective, targeted ads that are going to generate conversions for your
								business, get in touch with Moshi Moshi today.
							</h3>
							
						</div>
						
								</div>

                       
        

            </div>
        );
    }
}

export default GoogleAds;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeDo/GoogleAds.js